<script setup lang="ts">
import FirebaseService from '../../../../runtime/services/FirebaseService';

const { $log } = useLogging();
const { $firebase } = useFirebase();

const initFirebase = async (): Promise<void> =>
{
    try
    {
        const token = await $firebase.init();

        if (token)
        {
            await FirebaseService.setFirebaseToken(token);
        }
    }
    catch (ex)
    {
        $log.debug(ex);
    }
};

onBeforeMount(async (): Promise<void> =>
{
    await initFirebase();
});
</script>

<template>
    <div v-if="false" />
</template>
